import {H1, TextRegular} from '@hm/fundamental'
import {useTranslation} from 'react-i18next'

import {ReactComponent as FeatNotAvailable} from '../assets/featNotAvailable.svg'
import {InvalidSelectionLocationPicker} from '../Components/InvalidSelection/InvalidSelectionLocationPicker'

interface InvalidSelectionPageProps {
  variant?: 'scope' | 'plant'
}

export const InvalidSelectionPage: React.FC<InvalidSelectionPageProps> = ({variant = 'scope'}) => {
  const {t} = useTranslation()
  const isPlant = variant === 'plant'

  return (
    <div
      data-cy={isPlant ? 'feature_not_available_for_plant_page' : 'invalid_selection_page'}
      className="h-full flex flex-col items-center justify-center gap-6 text-center px-6 py-8"
    >
      <FeatNotAvailable aria-hidden="true" className="w-72 h-auto" />
      <div className="w-auto">
        <H1 className="text-foreground" data-cy="invalid_selection_title">
          {isPlant
            ? t('suite.featureNotAvailableForPlant.title')
            : t('suite.invalidSelection.title')}
        </H1>
        <div className="mt-6">
          <TextRegular
            className="text-foreground_faded text-lg font-normal"
            data-cy="invalid_selection_description"
          >
            {isPlant
              ? t('suite.featureNotAvailableForPlant.description')
              : t('suite.invalidSelection.description')}
          </TextRegular>
        </div>
      </div>
      <InvalidSelectionLocationPicker />
    </div>
  )
}
